module.exports = __webpack_public_path__ + "static/fonts/Inter-SemiBold.ec60b23f.ttf";